// extracted by mini-css-extract-plugin
module.exports = {"emailInput":"ForgotPasswordForm_emailInput__R9hbI","submitButton":"ForgotPasswordForm_submitButton__2EJHL"};